import { EntriEvents } from '@wix/domains-serverless-interface';
const DEFAULT_TIMEOUT_MS = 8000;
export const waitForEntriIframeReady = function (timeoutMs) {
  if (timeoutMs === void 0) {
    timeoutMs = DEFAULT_TIMEOUT_MS;
  }
  return new Promise(resolve => {
    const cleanup = () => {
      clearTimeout(timeoutId);
      window.removeEventListener(EntriEvents.onEntriStepChange, handler);
    };
    const handler = () => {
      cleanup();
      resolve();
    };
    window.addEventListener(EntriEvents.onEntriStepChange, handler);
    const timeoutId = setTimeout(() => {
      cleanup();
      resolve();
    }, timeoutMs);
  });
};
//# sourceMappingURL=waitForEntriIframeReady.js.map